import React, { useState } from "react";
import { Link } from "react-router-dom";

const Help = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How do I create an account?",
      answer:
        "Click on Sign Up, enter your details, verify your email, and you’re ready to go."
    },
    {
      question: "How do I reset my password?",
      answer:
        "Go to Login → Click 'Forgot Password' → Enter your email → Follow the reset instructions."
    },
    {
      question: "How do bookmarks work?",
      answer:
        "Tap the bookmark icon on any post. You can access all saved posts from your profile under Bookmarks."
    },
    {
      question: "How do I report a post or user?",
      answer:
        "Click the three dots on the post or profile and select 'Report'. Our moderation team will review it."
    },
    {
      question: "How do I download the Onnize mobile application?",
      answer: (
        <>
          Download the Onnize app{" "}
          <a
            href="https://play.google.com/store/apps/details?id=com.anonymous.onnizeapp&pcampaignid=web_share"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>{" "}
          or go to the Google Play Store, search for <strong>Onnize</strong>, and install it.
        </>
      ),
    },
    {
      question: "How do I contact support?",
      answer:
        "Send an email to info@onnize.com or use the contact form below."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div style={{ maxWidth: "800px", margin: "40px auto", padding: "20px" }}>
      <h1>Help Center</h1>
      <p>
        Find answers to common questions below. If you need further assistance,
        contact our support team.
      </p>

      <div style={{ marginTop: "30px" }}>
        {faqs.map((faq, index) => (
          <div
            key={index}
            style={{
              borderBottom: "1px solid #ddd",
              padding: "15px 0",
              cursor: "pointer"
            }}
            onClick={() => toggleFAQ(index)}
          >
            <h3 style={{ margin: 0 }}>{faq.question}</h3>
            {openIndex === index && (
              <p style={{ marginTop: "10px", color: "#555" }}>
                {faq.answer}
              </p>
            )}
          </div>
        ))}
      </div>

      <div style={{ marginTop: "50px" }}>
        <h2>Still Need Help?</h2>
        <p>Email: info@onnize.com</p>
      </div>
    </div>
  );
};

export default Help;
